import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Response = {};
type Variables = {
  id: number;
};

export const useCustomerPaymentMethodDelete = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async ({ id }) =>
    client({
      url: `v2/customers/payment-methods/${id}`,
      method: 'DELETE',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
